import { CommonMessages } from "../messages/validationMessages"
import * as Yup from 'yup'

export const addSelfServeOnlySubscriptionSchema = Yup.object().shape({
    location: Yup.array().required(CommonMessages.location_required).min(1, 'Select Location.'),
    subscription: Yup.string().required(CommonMessages.subscription_required),
    washname: Yup.string().required(CommonMessages.washname_required),
    washTime: Yup.number()
    .typeError('Enter valid wash time.')
    .when('subscription', {
      is: 'day',
      then: schema =>
        schema
          .min(1, 'Enter at least 1 minute.')
          .max(15, 'Maximum 15 minutes allowed')
          .required(CommonMessages.washtime_required),
      otherwise: schema =>
        schema
          .min(1, 'Enter at least 1 minute.')
          .max(120, 'Maximum 120 minutes allowed.')
          .required(CommonMessages.washtime_required),
    }),
    // washTime: Yup.string().matches(/^([1-9][0-9]{0,2})$/, 'Enter valid count.').required(CommonMessages.washtime_required),
    priceForExtraTime: Yup.number()
        .nullable()
        .transform((value, originalValue) => {
          return originalValue === '' || isNaN(originalValue) ? null : Number(originalValue);
        })
          .when(['subscription', 'canExtentSingleWash'], {
            is: (subscription: string, canExtentSingleWash: boolean | number) => subscription === 'day' && (canExtentSingleWash === true || canExtentSingleWash === 1),
            then: schema =>
                schema
            .typeError('Enter a valid amount.')
            .positive('Amount must be greater than 0.')
            .max(99999999.99, 'Amount is too large.')
            .required(CommonMessages.amount_required),
                    
            otherwise: schema => schema.notRequired(),
        }),
    amount: Yup.number()
    .nullable()
    .transform((value, originalValue) => {
      return originalValue === '' || isNaN(originalValue) ? null : Number(originalValue);
    })
    .when('subscription', {
      is: 'day',
      then: schema =>
          schema
      .typeError('Enter a valid amount.')
      .positive('Amount must be greater than 0.')
      .max(99999999.99, 'Amount is too large.')
      .required(CommonMessages.amount_required),
              
      otherwise: schema => schema.notRequired(),
  }),
    isPriceHoldEnabled: Yup.boolean(),
    isPriceHoldEmail: Yup.boolean(),
    // TEMP: Pre-Auth Amount - may need in future
    // preAuthAmount: Yup.number()
    //   .nullable()
    //   .transform((value, originalValue) => {
    //     if (originalValue === '' || originalValue === null || originalValue === undefined || isNaN(originalValue)) {
    //       return null;
    //     }
    //     const num = Number(originalValue);
    //     // Treat 0 as empty so required validation surfaces for unset pre-auth amounts
    //     return num === 0 ? null : num;
    //   })
    //   .when('subscription', {
    //     is: 'day',
    //     then: schema =>
    //       schema
    //         .typeError('Enter a valid pre-auth amount.')
    //         .positive('Pre-auth amount must be greater than 0.')
    //         .max(99999999.99, 'Pre-auth amount is too large.')
    //         .required(CommonMessages.preAuthAmount_required),
    //     otherwise: schema => schema.nullable().notRequired(),
    //   }),
  numberOfVacuumWashes: Yup.number()
    .nullable()
    .when('hasVacuumWash', {
      is: true,
      then: schema =>
        schema
          .typeError('Enter a valid number of vacuum washes.')
          .min(1, 'Must be greater than 0.')
          .required('Number of vacuum washes is required.'),
      otherwise: schema => schema.notRequired(),
    }),

  maxVacuumTime: Yup.number()
    .nullable()
    .when('hasVacuumWash', {
      is: true,
      then: schema =>
        schema
          .typeError('Enter a valid vacuum time.')
          .min(1, 'Must be greater than 0.')
          .required('Maximum vacuum time is required.'),
      otherwise: schema => schema.notRequired(),
    }),

})

export const addSelfServeSubscriptionSchema = Yup.object().shape({
    location: Yup.array().required(CommonMessages.location_required).min(1, 'Select Location.'),
    subscription: Yup.string().required(CommonMessages.subscription_required),
    washname: Yup.string().required(CommonMessages.washname_required),
    washTime: Yup.number()
    .typeError('Enter valid wash time.')
    .when('subscription', {
      is: 'day',
      then: schema =>
        schema
          .min(1, 'Enter at least 1 minute.')
          .required(CommonMessages.washtime_required),
      otherwise: schema =>
        schema
          .min(1, 'Enter at least 1 minute.')
          .max(120, 'Maximum 120 minutes allowed.')
          .required(CommonMessages.washtime_required),
    }),
    // washTime: Yup.string().matches(/^([1-9][0-9]{0,2})$/, 'Enter valid count.').required(CommonMessages.washtime_required),
    priceForExtraTime: Yup.number()
        .nullable()
        .transform((value, originalValue) => {
          return originalValue === '' || isNaN(originalValue) ? null : Number(originalValue);
        })
          .when(['subscription', 'canExtentSingleWash'], {
            is: (subscription: string, canExtentSingleWash: boolean | number) => subscription === 'day' && (canExtentSingleWash === true || canExtentSingleWash === 1),
            then: schema =>
                schema
            .typeError('Enter a valid amount.')
            .positive('Amount must be greater than 0.')
            .max(99999999.99, 'Amount is too large.')
            .required(CommonMessages.amount_required),
                    
            otherwise: schema => schema.notRequired(),
        }),
    amount: Yup.number()
    .nullable()
    .transform((value, originalValue) => {
      return originalValue === '' || isNaN(originalValue) ? null : Number(originalValue);
    })
    .when('subscription', {
      is: 'day',
      then: schema =>
          schema
      .typeError('Enter a valid amount.')
      .positive('Amount must be greater than 0.')
      .max(99999999.99, 'Amount is too large.')
      .required(CommonMessages.amount_required),
              
      otherwise: schema => schema.notRequired(),
  }),
    isPriceHoldEnabled: Yup.boolean(),
    isPriceHoldEmail: Yup.boolean(),
    // TEMP: Pre-Auth Amount - may need in future
    // preAuthAmount: Yup.number()
    //   .nullable()
    //   .transform((value, originalValue) => {
    //     if (originalValue === '' || originalValue === null || originalValue === undefined || isNaN(originalValue)) {
    //       return null;
    //     }
    //     const num = Number(originalValue);
    //     // Treat 0 as empty so required validation surfaces for unset pre-auth amounts
    //     return num === 0 ? null : num;
    //   })
    //   .when('subscription', {
    //     is: 'day',
    //     then: schema =>
    //       schema
    //         .typeError('Enter a valid pre-auth amount.')
    //         .positive('Pre-auth amount must be greater than 0.')
    //         .max(99999999.99, 'Pre-auth amount is too large.')
    //         .required(CommonMessages.preAuthAmount_required),
    //     otherwise: schema => schema.nullable().notRequired(),
    //   }),
    numberOfVacuumWashes: Yup.number()
    .nullable()
    .when('hasVacuumWash', {
      is: true,
      then: schema =>
        schema
          .typeError('Enter a valid number of vacuum washes.')
          .min(1, 'Maximum vacuum time must be greater than 0.')
          .required('Number of vacuum washes is required.'),
      otherwise: schema => schema.notRequired(),
    }),

  maxVacuumTime: Yup.number()
    .nullable()
    .when('hasVacuumWash', {
      is: true,
      then: schema =>
        schema
          .typeError('Enter a valid vacuum time.')
          .min(1, 'Maximum vacuum time must be greater than 0.')
          .required('Maximum vacuum time is required.'),
      otherwise: schema => schema.notRequired(),
    }),
})